import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  initialize() {
    const currentUrl = new URL(window.location.href)
    const downloadPath = currentUrl.searchParams.get("download")
    if (downloadPath) {
      const $downloadLink = document.querySelector(`[href="${downloadPath}"]`)

      if ($downloadLink) {
        $downloadLink.click()
      }
    }
  }
}
